<template>
    <modal name="single-element-modal-dialog" transition="pop-out" :width="modalWidth" :height="modalHeight"
           @before-open="beforeOpen" :style="backgroundColor">
        <loading :active.sync="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage"></loading>
        <div class="partition-title" :height="titleHeight"><h3>DEMO: {{title}}</h3></div>
        <div class="box" style="align-items: center;text-align:center">
            <iframe style="   width: 100%; height: 100%;" :src="src" @load="hideVueLoading"></iframe>
        </div>
    </modal>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    const MARGIN_FACTOR = 0.9;

    export default {
        name: 'SingleElementModalDialog',
        props: {
            name: String
        },
        components: {
            Loading
        },
        data() {
            return {
                items: [{
                    modalWidth: window.innerWidth * MARGIN_FACTOR,
                    modalHeight: window.innerHeight * MARGIN_FACTOR,
                    titleHeight: window.innerHeight * (1 - MARGIN_FACTOR)
                }],
                isLoading: true,
                fullPage: false,
                title: '...',
                src: "#",
                backgroundColor: "white"
            }
        },
        created() {
            this.modalWidth = window.innerWidth * MARGIN_FACTOR;
            this.modalHeight = window.innerHeight * MARGIN_FACTOR;
            this.titleHeight = window.innerHeight * (1 - MARGIN_FACTOR);
        },
        methods: {
            beforeOpen(event) {
                this.isLoading = true;
                this.backgroundColor = "background: " + event.params.rgba + " !important";
                this.title = event.params.title;
                this.src = event.params.demoSrc;
            },
            onCancel() {
                console.log('User cancelled the loader.')
            },
            hideVueLoading() {
                this.isLoading = false;
            }
        },
    }
</script>
<style lang="scss">

    .imageLoader {
        align-items: center;
    }

    .box {
        background: white;
        overflow: hidden;
        width: inherit;
        height: inherit;
        border-radius: 2px;
        box-sizing: border-box;
        box-shadow: 0 0 40px black;
        color: #8b8c8d;
        font-size: 0;
        background: url("../../assets/pic/iot-header.png") repeat-x left bottom;
        background-size: 400px 153px;
    }

    .pop-out-enter-active,
    .pop-out-leave-active {
        transition: all 0.5s;
    }

    .partition-title {
        position: relative;
        top: 0;
        text-align: center;
        background-color: white;
        width: inherit;
        border-radius: 2px;
        box-sizing: border-box;
        box-shadow: 0 0 5px black;
        color: #8b8c8d;
        font-size: 0;
        background-size: 400px 153px;
    }
</style>
